module.exports = __webpack_public_path__ + "img/2.6.CODm.2ae088b9.png";